import React from 'react'

import BasicRoute from 'components/routes/BasicRoute'

import EquipamentoConsulta from 'entity/Equipamento/components/EquipamentoConsulta'
import EquipamentoForm from 'entity/Equipamento/components/EquipamentoForm'

export default function RoutesMenusEquipamento() {
    return (
        <>
            <BasicRoute
                perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
                uid="consulta-equipamento"
                route="consulta-equipamento"

                menuProps={{
                    text: "Equipamentos",
                    sequence: "111117",
                    iconName: "Construction",

                    parent: {
                        uid: "parentCadastros",
                        text: "Cadastros",
                        sequence: "222222",
                        iconName: 'Edit'
                    }
                }}

                element={<EquipamentoConsulta />}
            />
            <BasicRoute
                uid="equipamento"
                route="_equipamento"
                element={<EquipamentoForm />}
            />
        </>
    )
}
